import { Component, OnInit, AfterViewInit, DoCheck, OnDestroy, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatDrawer, MatDialog } from '@angular/material';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { LoginService } from 'src/app/managers/login.service';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { User } from 'src/app/models/user';
import { ClientConfigService } from 'src/app/common/services/client-config.service';

@Component({
  selector: 'app-admin-myself',
  templateUrl: './admin-myself.component.html',
  styleUrls: ['./admin-myself.component.css']
})
export class AdminMyselfComponent extends BaseComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {
  @Output() OnUpdate: EventEmitter<User> = new EventEmitter<User>();
  @Input() drawer: MatDrawer;
  @ViewChild('newUsernameField', { static: true }) newUsernameElement: ElementRef;
  newUsername: string;
  newPassword: string;
  confirmPassword: string;
  submittable: boolean;  

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _snackBar: MatSnackBar) {
    super(route, loginManager, clientConfig, dialog);
    this.submittable = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.newUsername = this.getLoggedinUser().Email;
  }

  ngDoCheck() {
    this.submittable = this.isSubmittable();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.newUsernameElement.nativeElement.focus();
    }, 100);
  }

  ngDestroy() {
    super.ngOnDestroy();
  }

  private isSubmittable(): boolean {
    let submittable: boolean = false;

    if (this.newUsername && this.newPassword && this.confirmPassword) {
      if (this.newUsername.length > 0 && this.newPassword.length > 0 && this.confirmPassword.length > 0) {
        if (this.newPassword === this.confirmPassword)
          submittable = true;
      }
    }

    return submittable;
  }

  toggleDrawer() {
    this.drawer.toggle();
  }

  async updateAsync() {
    this._snackBar.open('Updating...');   
    let userToUpdate = new User();
    userToUpdate.Id = this.getLoggedinUser().Id;
    userToUpdate.Email = this.newUsername;
    userToUpdate.Password = this.confirmPassword;

    let responseMsg: CoreResponseMessage = await this.loginManager.updateUserAsync(userToUpdate);
  
    if (responseMsg.Status === CoreResponseStatus.OK) {
      this.loginManager.setLoggedinUser(responseMsg.Result);
      let newUser = this.loginManager.getLoggedinUser();    
      this.dataSource = newUser;

      this.OnUpdate.emit(this.getLoggedinUser());
      this._snackBar.dismiss();
    }
    else {
      this.openAlertDialog('Edit Myself', responseMsg.Message, '400px', '200px');
      this.handleCoreResponseMessageError(responseMsg);   
    }
  }
}
